import { render, staticRenderFns } from "./onePower.vue?vue&type=template&id=675d62ea&scoped=true"
import script from "./onePower.vue?vue&type=script&lang=js"
export * from "./onePower.vue?vue&type=script&lang=js"
import style0 from "./onePower.vue?vue&type=style&index=0&id=675d62ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675d62ea",
  null
  
)

export default component.exports